<template>
  <v-layout>
    <v-dialog v-model="show" width="1000">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Email Template</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.name"
                label="Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.description"
                label="Description"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <wysiwyg v-model="editedItem.emailHtml" />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editedItem.sendForm"
                :items="active"
                item-text="title"
                item-value="value"
                label="Send Form"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editedItem.active"
                :items="active"
                item-text="title"
                item-value="value"
                label="Active"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveType(false)">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { mask } from 'vue-the-mask'

export default {
  props: ['visible', 'item'],

  directives: {
    mask,
  },

  data() {
    return {
      active: [
        { title: 'Yes', value: true },
        { title: 'No', value: false },
      ],
      drawMask: '##',
      editedItem: this.item,
      saving: false,
      showpassword: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
    }
  },

  created() {
    this.loadItem()
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.editedItem)
        }
      },
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function() {
        this.saving = true
      },
      deep: true,
    },
  },

  methods: {
    loadItem() {
      this.editedItem = this.item
    },

    async saveType() {
      if (this.editedItem.id) {
        try {
          const response = await Api().put(
            'email_templates/' + this.editedItem.id,
            this.editedItem
          )

          this.show = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (e) {
          this.snackbar.message = e.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } else {
        try {
          this.editedItem.ClientId = this.$store.state.client.id

          const response = await Api().post('test_type', this.editedItem)

          this.editedItem.id = response.data.testType.id

          this.show = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (e) {
          this.snackbar.message = e.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },
  },
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>
